import { transformDateToLocalDateString } from "helpers";
import { ActivityLogRow, ActivityLogTypeEnum } from "services/api/fleet/vehicles/activitylogs/types";
import { FleetVehicle, FleetVehicleDetailFormValues } from "services/api/fleet/vehicles/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";
import VehicleCell from "ui/components/Table/TableSearch/components/Cells/VehicleCell";
import Tooltip from "ui/components/Tooltip/Tooltip";
import ActivityChangeList from "../ActivityChangeList/ActivityChangeList";
import { getActivityTypeConfig, getChangeCountLabel } from "../VehicleHistoryTimeline/consts";

export const FLEET_VEHICLE_HISTORY_SEARCH_COLUMNS = (
  t: (key: string) => string,
  vehicle?: FleetVehicleDetailFormValues
): Column[] => [
  {
    title: "Datum",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ActivityLogRow) => {
      const date = new Date(row.created);
      return (
        <div>
          <div className="text-sm text-slate-900">{transformDateToLocalDateString(new Date(row.created))}</div>
          <div className="text-xs text-slate-500">{date.toLocaleTimeString("hr-HR", { hour: "2-digit", minute: "2-digit" })}</div>
        </div>
      );
    },
  },
  {
    title: "Vrsta",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ActivityLogRow) => (
      <Badge
        text={row.activityLogTypeName}
        variant={getActivityTypeConfig(row.activityLogType).badgeVariant}
        height="small"
        showDot
      />
    ),
  },
  {
    title: "Entitet",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ActivityLogRow) => {
      const isVehicleCreate =
        row.activityLogType === ActivityLogTypeEnum.Create && !!vehicle && row.entityId === vehicle.id;

      return (
         <div className="text-sm text-slate-700">{row.entityDescription ?? ""}</div>
      );
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ActivityLogRow) => {
      const isVehicleCreate =
        row.activityLogType === ActivityLogTypeEnum.Create && !!vehicle && row.entityId === vehicle.id;

      return (
        <div className="flex items-center justify-center gap-3">
        
          {isVehicleCreate && (
            <div className="mt-2">
              <VehicleCell vehicle={vehicle as unknown as FleetVehicle} />
            </div>
          )}
          
        </div>
      );
    },
  },
  {
    title: "Opis",
    field: "",
    type: ColumnTypes.custom,
    // Stupac nosi samo što je napravljeno — popis izmjena je razvlačio retke na više
    // redaka i tablica se prestala čitati. Detalji su na hover.
    render: (row: ActivityLogRow) => {
      const changeCount = row.changes?.length ?? 0;

      const description = (
        <div className="max-w-[400px]">
          <div className="text-sm text-slate-700">{row.comment}</div>
          {changeCount > 0 && (
            <span className="text-xs text-slate-400 border-b border-dashed border-slate-300 cursor-help">
              {changeCount} {getChangeCountLabel(changeCount)}
            </span>
          )}
        </div>
      );

      if (changeCount === 0) return description;

      return (
        <Tooltip position="bottom-right" trigger={description} interactive>
          <div className="max-w-[420px]">
            <ActivityChangeList changes={row.changes!} variant="dark" />
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "Korisnik",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ActivityLogRow) => (
      <div className="text-sm text-slate-700">{row.userFullName}</div>
    ),
  },
];
